import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchAllOrders, fetchAllPayments } from "../../services/paymentService";

export const loadPaymentsData = createAsyncThunk(
  "paymentsTracker/loadPaymentsData",
  async (_, { rejectWithValue }) => {
    try {
      const [orders, paymentsMap] = await Promise.all([
        fetchAllOrders(),
        fetchAllPayments(),
      ]);
      return { orders, paymentsMap };
    } catch (err) {
      return rejectWithValue(err.message || "Failed to fetch data");
    }
  }
);

const paymentsTrackerSlice = createSlice({
  name: "paymentsTracker",
  initialState: {
    orders: [],
    paymentsMap: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadPaymentsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loadPaymentsData.fulfilled, (state, action) => {
        state.loading = false;
        state.orders = action.payload.orders;
        state.paymentsMap = action.payload.paymentsMap;
      })
      .addCase(loadPaymentsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default paymentsTrackerSlice.reducer;
